import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataResponse } from 'shared/common';
import { AbstractApiService } from 'src/app/nio-common/services/abstract-api-service.service';
import { environment } from 'src/environments/environment';
import { CartDisplayResponse, CheckoutResponse, GuestCustomerInfo } from '../models/cart.model';

@Injectable({
  providedIn: 'root',
})
export class GuestCheckoutService extends AbstractApiService {
  constructor(private readonly httpClient: HttpClient) {
    super(`${environment.backendServiceUrl}/v1/payment/guest`, httpClient);
  }

  async displayCart(photoIds: string[]): Promise<CartDisplayResponse | null> {
    try {
      const res = await this.post<DataResponse<CartDisplayResponse>>('/cart/display', {
        photoIds,
      });
      return res.body?.data || null;
    } catch (error) {
      console.error('Error displaying cart:', error);
      throw error;
    }
  }

  async guestCheckout(
    photoIds: string[],
    customerInfo: GuestCustomerInfo,
  ): Promise<CheckoutResponse | null> {
    try {
      const res = await this.post<DataResponse<CheckoutResponse>>('/checkout', {
        photoIds,
        customerInfo,
      });
      return res.body?.data || null;
    } catch (error) {
      console.error('Error during guest checkout:', error);
      throw error;
    }
  }

  async checkPaymentStatus(transactionId: string): Promise<any> {
    try {
      const res = await this.post<DataResponse<any>>(`/status/${transactionId}`, {});
      return res.body?.data || null;
    } catch (error) {
      console.error('Error checking payment status:', error);
      throw error;
    }
  }
}
